import AfgorelserTable from "@cle/components/injunctions/AfgorelserTable";
import RoundedCard from "@cle/components/RoundedCard";
import ViewLayout from "@cle/components/ViewLayout";
import { useAfgorelser } from "@cle/hooks/useAfgorelser";
import AfgorelserInfoContent from "./components/AfgorelserInfoContent";

const AfgorelserView = () => {
  const { data: afgorelser = [], isError, isLoading } = useAfgorelser();

  return (
    <ViewLayout
      title="Afgørelser"
      description="Her kan du se dine afgørelser om efteruddannelse, status og relevante frister."
      infoTitle="Sådan læser du dine afgørelser"
      infoDescription="Påbud og pålæg, frister, lektionskrav og status"
      infoText={<AfgorelserInfoContent />}
    >
      <RoundedCard
        className="mt-4"
        bodyClassName="p-0 mt-3"
        header="Mine afgørelser"
        description="Oversigt over dine påbud, pålæg og dokumentationsstatus."
      >
        <AfgorelserTable
          afgorelser={afgorelser}
          isError={isError}
          isLoading={isLoading}
        />
      </RoundedCard>
    </ViewLayout>
  );
};

export default AfgorelserView;
